import { InMemoryCache } from '@apollo/client/core';

export const apolloCache = new InMemoryCache({
  typePolicies: {},
});
